// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2-19V","image":"Header_image__Z2HID","name":"Header_name__VRjXc","info":"Header_info__Sc7Gx","infoRow":"Header_infoRow__H4a1J"};